import React from "react";
import Logo from "../components/Logo";
import Navigation from "../components/Navigation";
import { useTranslation } from 'react-i18next';
const About = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Logo />
      <Navigation />

     <div className="policie">
      <h1>{t("privacy_policy_title")}</h1>
      <br />
      <br />
      
      
      <p>  {t("privacy_policy_intro")}  
      </p>
      
      <br />
      <h2>{t("data_collection_and_use")}</h2>
      
      <p>{t("data_collection_description")}
      </p>
      
      <br />
      <h2>{t("security_title")}
      </h2>
      
      <p>
      {t("security_description")}
      </p>
      
      <br />
      <h2>
      {t("policy_changes_title")}
      </h2>
      
      <p>
      {t("policy_changes_description")}
      </p>
      
      
      <br />
      <h2>
      {t("contact_us_title")}
      </h2>
      
      <p>
      {t("contact_us_description")}
      </p>
      <br />
      <p>
      {t("email")}
      </p> 
      <br />
      <br />
      <p>
      {t("signature")}
      </p>

      </div>

      
    </div>
  );
};

export default About;
